module.exports = __webpack_public_path__ + "static/media/demmeler.68abc68a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/demmeler.png
// module id = 455
// module chunks = 0